import type { BackendEnvironment } from '@core/environment-legacy';

export const RECRUITEE_BACKEND = (<const>{
  protocol: 'https',
  referralsProtocol: 'https',
  domain: 'api.recruitee.com',
  partialDomain: 'recruitee.com',
  referralsPartialDomain: 'referrals.co',
  apiUrl: 'https://api.recruitee.com',
  authUrl: 'https://auth.recruitee.com',
  appUrl: 'https://recruitee.com',
  webAppUrl: 'https://app.recruitee.com',
  mobileAppUrl: 'https://mobile.recruitee.com',
  wsUrl: 'wss://api.recruitee.com/socket',
  widgetUrl: 'https://jobs-widget.recruiteecdn.com/widget.js',
  widgetApiEndpoint: 'https://career.recruitee.com/api/c',
  videoAppUrl: 'https://meet.recruitee.com',
  CDNHost: 'https://app.recruitee.com',
  pdfViewerDirectory: 'pdfjs-patched',
  integrationsUrl: 'https://integrations.recruitee.com',
  tellentApiUrl: 'https://api.tellent.com',
  tellentAuthUrl: 'https://auth.tellent.com',
  tellentAppUrl: 'https://admin.tellent.com',
  tellentAppWsUrl: 'wss://api.tellent.com/socket',
  reportsApiUrl: 'https://analytics.tellent.com',
  tellentOneDomainUrl: 'https://app.tellent.com',
  tellentWebsiteUrl: 'https://tellent.com',
}) satisfies BackendEnvironment;
